/**
 * APP
 * a helper class for websites
 * @author Arpad Hegedus <hegedus.arpad@gmail.com>
 * @version 1.0.0
 */

let Element = require('./el.js');

module.exports = class App {

    // data transfer through ajax
    ajax(method, url, ...data) {
        return new Promise((resolve, reject) => {
            let request = new XMLHttpRequest(),
                headers = null,
                post = null,
                ret = false;
            if (data && data.indexOf('json') >= 0) { ret = 'json'; data.splice(data.indexOf('json'), 1); }
            if (data && data.length === 1) { headers = data[0]; }
            if (data && data.length > 1) { post = data[0]; headers = data[1]; }
            request.open(method, url, true);
            if (headers) {
                for (let [header, value] of Object.entries(headers)) { request.setRequestHeader(header, value); }
                if ('Authorization' in headers) { request.withCredentials = true; }
            }
            request.onload = () => {
                if (request.status !== 200) { reject(request); }
                else {
                    request.body = request.responseText;
                    if (ret === 'json') { request.body = JSON.parse(request.body); }
                    resolve(request);
                }
            }
            request.onerror = () => { reject(request); }
            if (post) {
                request.send(post);
            } else {
                request.send();
            }
        });
    }

    // add a class to an element
    addClass(els, className) {
        new Element(els).addClass(className);
    }

    animate(elements, ...settings) {
        elements = new Element(elements);
        let animate = null;
        let options = { duration: this.animation.speed, easing: this.animation.ease };
        let numbersFound = 0; let funcsFound = 0;
        let loadWhat = 'velocity'; let maybe = false;
        settings.forEach(setting => {
            if (typeof setting === 'string' && setting === 'maybe') {
                maybe = true;
            } else if (typeof setting === 'string' && setting === 'loop') {
                options.loop = true;
            } else if (typeof setting === 'string' && setting === 'queue') {
                options.queue = true;
            } else if (typeof setting === 'string' && setting === 'no-queue') {
                options.queue = false;
            } else if (typeof setting === 'number') {
                if (numbersFound == 2) {
                    options.loop = setting;
                } else if (numbersFound == 1) {
                    options.delay = setting;
                } else {
                    options.duration = setting;
                }
                numbersFound++;
            } else if (typeof setting === 'string' && ['ease', 'ease-in', 'ease-out', 'ease-in-out', 'easeInSine', 'easeOutSine', 'easeInOutSine', 'easeInQuad', 'easeOutQuad', 'easeInOutQuad', 'easeInCubic', 'easeOutCubic', 'easeInOutCubic', 'easeInQuart', 'easeOutQuart', 'easeInOutQuart', 'easeInQuint', 'easeOutQuint', 'easeInOutQuint', 'easeInExpo', 'easeOutExpo', 'easeInOutExpo', 'easeInCirc', 'easeOutCirc', 'easeInOutCirc', 'spring'].indexOf(setting) >= 0) {
                options.easing = setting;
            } else if (typeof setting === 'string' && ['block', 'none', 'flex', 'table', 'inline', 'inline-block'].indexOf(setting) >= 0 || setting === null) {
                options.display = setting;
            } else if (typeof setting === 'string' && ['fadeIn', 'fadeOut', 'slideUp', 'slideDown'].indexOf(setting) >= 0) {
                animate = setting;
            } else if (typeof setting === 'string' && ['callout.bounce', 'callout.shake', 'callout.flash', 'callout.pulse', 'callout.swing', 'callout.tada', 'transition.fadeIn', 'transition.fadeOut', 'transition.flipXIn', 'transition.flipXOut', 'transition.flipYIn', 'transition.flipYOut', 'transition.flipBounceXIn', 'transition.flipBounceXOut', 'transition.flipBounceYIn', 'transition.flipBounceYOut', 'transition.swoopIn', 'transition.swoopOut', 'transition.whirlIn', 'transition.whirlOut', 'transition.shrinkIn', 'transition.shrinkOut', 'transition.expandIn', 'transition.expandOut', 'transition.bounceIn', 'transition.bounceOut', 'transition.bounceUpIn', 'transition.bounceUpOut', 'transition.bounceDownIn', 'transition.bounceDownOut', 'transition.bounceLeftIn', 'transition.bounceLeftOut', 'transition.bounceRightIn', 'transition.bounceRightOut', 'transition.slideUpIn', 'transition.slideUpOut', 'transition.slideDownIn', 'transition.slideDownOut', 'transition.slideLeftIn', 'transition.slideLeftOut', 'transition.slideRightIn', 'transition.slideRightOut', 'transition.slideUpBigIn', 'transition.slideUpBigOut', 'transition.slideDownBigIn', 'transition.slideDownBigOut', 'transition.slideLeftBigIn', 'transition.slideLeftBigOut', 'transition.slideRightBigIn', 'transition.slideRightBigOut', 'transition.perspectiveUpIn', 'transition.perspectiveUpOut', 'transition.perspectiveDownIn', 'transition.perspectiveDownOut', 'transition.perspectiveLeftIn', 'transition.perspectiveLeftOut', 'transition.perspectiveRightIn', 'transition.perspectiveRightOut'].indexOf(setting) >= 0) {
                animate = setting;
                loadWhat = 'velocity-ui';
            } else if (typeof setting === 'function') {
                if (funcsFound == 2) {
                    options.progress = setting;
                } else if (funcsFound == 1) {
                    options.befin = setting;
                } else {
                    options.complete = setting;
                }
                funcsFound++;
            } else if (typeof setting === 'object' && (setting.nodeType === Node.ELEMENT_NODE) || setting[0] && setting[0].nodeType === Node.ELEMENT_NODE) {
                elements = setting;
            } else if (typeof setting === 'object') {
                animate = (animate) ? animate : setting;
                options = (animate) ? setting : options;
            }
        });
        if (maybe) {
            if (this.__imported.indexOf(loadWhat) >= 0) {
                maybe = false;
            } else {
                this.import(loadWhat);
            }
        }
        if (!maybe) {
            this.import(loadWhat).then(() => {
                elements.forEach(el => {
                    if (window.jQuery && window.jQuery.Velocity) {
                        window.jQuery.Velocity(el.node, 'finish');
                        window.jQuery.Velocity(el.node, animate, options);
                    } else if (Velocity) {
                        Velocity(el.node, 'finish');
                        Velocity(el.node, animate, options);
                    }
                });
            });
        }
    }

    animateSeq(sequence) {
        sequence.forEach((v, i) => {
            if (typeof v.e === 'string') {
                sequence[i].e = new Element(v.e).elements;
            }
        });
        this.import('velocity-ui').then(() => {
            if (window.jQuery && window.jQuery.Velocity) {
                window.jQuery.Velocity.RunSequence(sequence);
            } else if (Velocity) {
                Velocity.RunSequence(sequence);
            }
        });
    }

    // initialize the class    
    constructor() {

        // add support for foreach in nodelists
        (function () {
            if (typeof NodeList.prototype.forEach === "function") { return false; }
            NodeList.prototype.forEach = Array.prototype.forEach;
        })();

        // breakpoint for desktop and mobile media queries
        this.breakpoint = 768;

        // path
        this.pathPrepend = '';

        // default animation settings
        this.animation = {
            speed: 200,
            ease: [.55, 0, .1, 1]
        }

        // set import timeout for loading external modules        
        this.importInterval = 300;

        // default interval for app timeouts
        this.timeoutInterval = 50;

        // touchscreen information
        this.isTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;

        // useful keycodes
        this.keycode = {
            tab: 9,
            enter: 13,
            esc: 27,
            space: 32,
            pageup: 33,
            pagedown: 34,
            home: 36,
            left: 37,
            up: 38,
            right: 39,
            down: 40
        }

        // setup modules to be dynamically called
        this.__modules = {};

        // init default properties
        this.__imported = [];
        this.__importing = [];
        this.__load = [];
        this.__resize = [];
        this.__scroll = [];
        this.__webcomponents = {}
    }

    // debounces a function so that it is not called as long as it is continued to be invoked
    debounce(func, wait = 300) {
        let timeout, result,
            later = (context, args) => {
                timeout = null;
                if (args) {
                    result = func.apply(context, args);
                }
            };
        return () => {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            timeout = setTimeout(later, wait, this, arguments);
            return result;
        }

    }

    // check if element exists    
    exists(selector, el = null) {
        el = (el) ? el : document;
        return el.querySelector(selector) !== null;
    }

    // update width when called when getting property
    get width() { return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth; }

    // update height when called when getting property
    get height() { return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight; }

    // update scroll information when getting property
    get scroll() {
        return {
            x: (window.pageXOffset || document.documentElement.scrollLeft) - (document.documentElement.clientLeft || 0),
            y: (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0)
        }
    }

    // element selector with advanced features
    el(selector) {
        return new Element(selector);
    }

    // get element height
    getHeight(el) {
        return new Element(el).height;
    }

    // get element width
    getWidth(el) {
        return new Element(el).width;
    }

    // check if element has a class
    hasClass(els, className) {
        return new Element(els).hasClass(className);
    }

    // import a module
    import(name) {

        // module not registered
        if (name in this.__modules === false) { return Promise.reject(`${name} module is not registered`); }

        // module already loaded
        if (this.__imported.includes(name)) { return Promise.resolve(`${name} is already loaded`); }

        // module currently being loaded
        if (this.__importing.includes(name)) {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    this.import(name).then(m => { resolve(m); }).catch(e => { reject(e); });
                }, this.importInterval);
            });
        }

        // load dependencies
        if (this.__modules[name].deps && this.__modules[name].deps.length > 0) {
            let dependencies = [];
            this.__modules[name].deps.forEach(dep => {
                if (!this.__imported.includes(dep)) {
                    dependencies.push(this.import(dep));
                }
            });
            if (dependencies.length > 0) {
                return Promise.all(dependencies).then(m => {
                    return this.import(name);
                }).catch(e => {
                    return Promise.reject(e);
                });
            }
        }

        // importing module
        this.__importing.push(name);

        // try sources one by one
        if ('tried' in this.__modules[name]) {
            this.__modules[name].tried++;
        } else {
            this.__modules[name].tried = 0;
        }

        // load
        return new Promise((resolve, reject) => {

            // check if sources were all tried
            if (this.__modules[name].tried >= this.__modules[name].srcs.length) {
                reject(`Source files not found. Unable to load module: "${name}"`);
            }

            // setup element-to-be-added
            let src = this.__modules[name].srcs[this.__modules[name].tried],
                type = src.split('.').splice(-1)[0].split('?')[0],
                element = (type === 'css') ? 'link' : 'script',
                placement = (type === 'css') ? 'head' : 'body',
                loaded = false;
            element = document.createElement(element);
            if (type === 'css') {
                element.href = this.path(src);
                element.rel = 'stylesheet';
            } else {
                element.src = this.path(src);
                element.async = 'true';
            }


            // check if element has error
            element.onerror = e => {
                e.target.parentNode.removeChild(e.target);
                console.log(`Failed to load the source of ${name}: ${src}`);
                this.import(name).then(m => { resolve(m); }).catch(e => { reject(e); })
            }

            // check if element has loaded properly
            element.onload = () => {
                // module already loaded
                if (name in this.__imported) { console.log(`${name} is already loaded`); return Promise.resolve(`${name} is already loaded`); }

                if (loaded === false) {
                    this.__imported.push(name);
                    this.__modules[name].loaded = true;
                    console.log(`Loaded module: "${name}" (${src})`);
                    resolve(`Loaded module: "${name}" (${src})`);
                    loaded = true;
                }
            }

            // add element
            document.getElementsByTagName(placement)[0].appendChild(element);

            // check if element has loaded (css)
            if (type === 'css') {
                // module already loaded
                if (name in this.__imported) { console.log(`${name} is already loaded`); return Promise.resolve(`${name} is already loaded`); }

                let img = document.createElement('img');
                img.onerror = e => {
                    if (loaded === false) {
                        this.__imported.push(name);
                        this.__modules[name].loaded = true;
                        console.log(`Loaded module: "${name}" (${src})`);
                        resolve(`Loaded module: "${name}" (${src})`);
                        loaded = true;
                    }
                }
                img.src = src;
            }
        });
    }

    // check if current screen is narrow 
    get isNarrow() {
        return this.breakpoint >= this.width;
    }

    // check if variable is a number
    isNumeric(variable) {
        return (!isNaN(parseFloat(variable)) && isFinite(variable));
    }

    // check if an element is visible in the viewport
    isInViewport(el, offsetY = 0, offsetX = 0) {
        return new Element(el).isInViewport(offsetY, offsetX);
    }

    // check if current screen is wide
    get isWide() {
        return this.breakpoint < this.width;
    }

    // load modules
    loadModules() {
        for (let [name, mod] of Object.entries(this.modules)) {
            this.import(name, mod);
        }
    }

    // load webcomponents
    loadWebcomponents() {
        let e = this;
        if (Object.keys(this.__webcomponents).length !== 0 && this.exists(Object.keys(this.__webcomponents).join(', '))) {
            this.import('webcomponents-loader').then(() => {
                for (let [selector, path] of Object.entries(e.__webcomponents)) {
                    if (e.exists(selector) && !e.exists(`link[rel="import"][href$="${path}"]`)) {
                        let link = document.createElement('link');
                        link.rel = 'import'; link.href = e.path(path);
                        document.querySelector('body').appendChild(link);
                    }
                }
            });
        }
    }

    // return path to theme folder
    path(path) {
        return (path.indexOf('/') === 0 || path.indexOf('http') === 0) ? path : this.pathPrepend + path;
    }

    // document ready
    ready(func) {
        if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
            func();
        } else {
            document.addEventListener('DOMContentLoaded', func);
        }
    }

    // register functions to run at load, scroll or resize events
    register(event, func) {
        event = (Array.isArray(event)) ? event : [event];
        event.forEach(e => {
            this[`__${e}`].push(func);
        });
    }

    // register module to be imported
    registerModule(name, srcs, deps = null) {
        if (typeof srcs === 'string') { srcs = [srcs]; }
        this.__modules[name] = {
            srcs: srcs,
            deps: deps
        };
    }

    // register webcomponent to be used
    registerWebcomponent(selector, path) {
        this.__webcomponents[selector] = path;
    }

    // remove a class from an element
    removeClass(els, className) {
        new Element(els).removeClass(className);
    }

    // run registered events   
    run(ready = true, resize = true, scroll = true, webcomponents = true) {
        let app = this;
        if (webcomponents) {
            app.loadWebcomponents();
        }
        if (ready && this.__load.length > 0) {
            app.ready(() => {
                app.__load.forEach(f => { f(); });
            });
        }
        if (resize && this.__resize.length > 0) {
            window.addEventListener('resize', app.throttle(() => {
                app.__resize.forEach(f => { f(); });
            }, app.timeoutInterval));
        }
        if (scroll && this.__scroll.length > 0) {
            window.addEventListener('scroll', app.throttle(() => {
                app.__scroll.forEach(f => { f(); });
            }, app.timeoutInterval));
        }
    }

    // convert text to relevant js data
    textToData(text) {
        // only do checks for strings
        if (typeof text == 'string') {

            // parse passed in data
            if (
                text === 'true'
                ||
                text === 'false'
                ||
                (!isNaN(parseFloat(text)) && isFinite(text))
            ) {
                try {
                    var tryjson = JSON.parse(JSON.stringify(eval('(' + text + ')')));
                    text = tryjson;
                } catch (e) { }
            }

            // parse passed in arrays
            else if (text.indexOf('{') >= 0 && text.indexOf('}') >= 0) {
                try {
                    var tryjson = JSON.parse(JSON.stringify(eval('(' + text + ')')));
                    text = tryjson;
                } catch (e) { }
            }

            // parse passed in arrays
            else if (text.indexOf('[') >= 0 && text.indexOf(']') >= 0) {
                try {
                    var tryjson = JSON.parse(JSON.stringify(eval(text)));
                    text = tryjson;
                } catch (e) { }
            }

            // get variables passed in
            else if (text.indexOf('var ') === 0 && app.isset(window[text.replace(/(var\s)/g, '')])) {
                text = window[text.replace(/(var\s)/g, '')];
            }

            // set to true if value is empty string
            else if (text === '') { text = true; }
        }

        return text;
    }

    // toggle a class on an element
    toggleClass(els, className) {
        new Element(els).toggleClass(className);
    }

    // throttle a function so that it doesn't execute too fast too often
    throttle(func, wait = 300) {
        let context, args, result, previous = 0, timeout = null;
        later = () => {
            previous = Date.now();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) {
                context = null;
                args = null;
            };
        }
        return () => {
            let now = Date.now(),
                remaining = now - previous,
                context = this,
                args = arguments;
            if (remaining <= 0 || remaining > wait) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) {
                    context = null;
                    args = null;
                }
            } else if (!timeout) {
                timeout = setTimeout(later, remaining);
            }
            return result;
        }
    }
}


// WEBPACK FOOTER //
// ./es6/modules/app.js